import { inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { HttpInterceptorFn } from '@angular/common/http';

export const publicationInterceptor: HttpInterceptorFn = (req, next) => {
  const oktaAuthService = inject(OKTA_AUTH);
  const accessToken = oktaAuthService.getAccessToken();
  if (accessToken) {
    //Replacing the Authorization header
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        withCredentials: 'true',
      },
    });
    return next(clonedReq);
  } else {
    return next(req);
  }
};
